// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3-1mg","title":"ClientInsurance_title__3u2hq","itemText":"ClientInsurance_itemText__10vEk"};